import { Cancel } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ListRequest from "./components/ListRequest";
import CancelRequest from "./components/CancelRequest";
import DoneRequest from "./components/DoneRequest";
function Request() {
  const [type, setType] = useState(localStorage.getItem("reqType")?`${localStorage.getItem("reqType")}`:"0");
  const [counts, setCounts] = useState({
    active:0,
    cancel:0,
    done:0
  })
  console.log(counts,"countssssssssss")
  useEffect(()=>{
  localStorage.setItem("reqType", type);
},[type])
  return (
    <>
      <div className="status-buttons mb-3">
        <span
          onClick={() => setType("0")}
          className={
            type === "0"
              ? "custom-btn-small custom-button-extra-small req-status-button req-active active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-active"
          }
        >
          Active ({counts.active})
        </span>
        <span
          onClick={() => setType("1")}
          className={
            type === "1"
              ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled  active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled "
          }
        >
          Cancelled ({counts.cancel})
        </span>
        <span
          onClick={() => setType("2")}
          className={
            type === "2"
              ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0"
          }
        >
          Done ({counts.done})
        </span>
        {/* <span
          onClick={() => setType("3")}
          className={
            type === "3"
              ? "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled mt-2 mt-sm-0 active"
              : "custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled mt-2 mt-sm-0"
          }
        >
          Rejected
        </span> */}

        <div className="clearfix"></div>
      </div>
      {/* table calling */}

      {type === "0" && <ListRequest counts={counts} setCounts={setCounts} />}
      {type === "1" && <CancelRequest counts={counts} setCounts={setCounts} />}
      {type === "2" && <DoneRequest counts={counts} setCounts={setCounts} />}
    </>
  );
}
export default withRouter(Request);
